export function ValidateCPF(cpf) {
  var Sum = 0;
  var Modulus;

  for (let i = 0; i <= 9; i++) {
    let invalid = String(i).repeat(11);
    if (cpf === invalid) {
      return false;
    }
  }

  for (let i = 1; i <= 9; i++) {
    Sum = Sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  Modulus = (Sum * 10) % 11;

  if (Modulus === 10 || Modulus === 11) Modulus = 0;
  if (Modulus !== parseInt(cpf.substring(9, 10))) return false;

  Sum = 0;
  for (let i = 1; i <= 10; i++) {
    Sum = Sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  Modulus = (Sum * 10) % 11;

  if (Modulus === 10 || Modulus === 11) Modulus = 0;
  if (Modulus !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

export function validateEmail(email) {
  return /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
    email
  );
}

export function validatePhoneNumber(phone) {
  return /^\(?(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4}$/.test(
    phone
  );
}
